export const T = {
  en_GB: {
    scope: "Scope:",
    scopes: { global: "Global", client: "Client", system: "System" },
    scopeDescriptions: {
      global: "Shown when starting a new AI Agent chat.",
      client: "Shown when starting a new chat from a client page.",
      system: "Shown in the Design Agent chat (designers only — portfolio collections & products).",
    },
    loading: "Loading...",
    noPrompts: "No custom prompts yet — defaults are shown until you add one.",
    titlePlaceholder: "Title (shown in the list)",
    textPlaceholder: "Prompt sent to the chat when clicked",
    title: "Title",
    prompt: "Prompt",
    cancel: "Cancel",
    save: "Save",
    addPrompt: "Add prompt",
    edit: "Edit",
    delete: "Delete",
    failedToSave: "Failed to save prompt",
    failedToUpdate: "Failed to update prompt",
    failedToDelete: "Failed to delete prompt",
    unexpectedError: "Unexpected error",
  },
  nb_NO: {
    scope: "Omfang:",
    scopes: { global: "Global", client: "Kunde", system: "System" },
    scopeDescriptions: {
      global: "Vises når du starter en ny chat med AI-agenten.",
      client: "Vises når du starter en ny chat fra en kundeside.",
      system:
        "Vises i chatten med designagenten (kun for designere — porteføljesamlinger og produkter).",
    },
    loading: "Laster...",
    noPrompts: "Ingen egne forslag ennå — standardforslagene vises til du legger til ett.",
    titlePlaceholder: "Tittel (vises i listen)",
    textPlaceholder: "Teksten som sendes til chatten ved klikk",
    title: "Tittel",
    prompt: "Forslag",
    cancel: "Avbryt",
    save: "Lagre",
    addPrompt: "Legg til forslag",
    edit: "Rediger",
    delete: "Slett",
    failedToSave: "Kunne ikke lagre forslaget",
    failedToUpdate: "Kunne ikke oppdatere forslaget",
    failedToDelete: "Kunne ikke slette forslaget",
    unexpectedError: "Uventet feil",
  },
} as const;
